module.exports = "/images/vendor/flag-icon-css/flags/1x1/ao.svg?ab8cc21b5392f6d7b213e6349c7237c2";